module.exports = __webpack_public_path__ + "img/03d.a1cb48a6.png";